"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('startup-layout', {
    ref: "layout",
    staticClass: "kiwi-welcome-simple"
  }, [_c('div', {
    attrs: {
      "slot": "connection"
    },
    slot: "connection"
  }, [[_c('form', {
    staticClass: "u-form kiwi-welcome-simple-form",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.formSubmit.apply(null, arguments);
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.greetingText)
    }
  }), _vm.network && (_vm.network.last_error || _vm.network.state_error) ? _c('div', {
    staticClass: "kiwi-welcome-simple-error"
  }, [_vm._v(" We couldn't connect to the server :( "), _c('span', [_vm._v(" " + _vm._s(_vm.network.last_error || _vm.readableStateError(_vm.network.state_error)) + " ")])]) : _vm._e(), _vm.showNick ? _c('input-text', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "kiwi-welcome-simple-nick",
    attrs: {
      "label": _vm.$t('nick')
    },
    model: {
      value: _vm.nick,
      callback: function callback($$v) {
        _vm.nick = $$v;
      },
      expression: "nick"
    }
  }) : _vm._e(), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.useLawnmower,
      expression: "useLawnmower"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useLawnmower) ? _vm._i(_vm.useLawnmower, null) > -1 : _vm.useLawnmower
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.useLawnmower,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.useLawnmower = (0, _concat.default)($$a).call($$a, [$$v]));
          } else {
            var _context;
            $$i > -1 && (_vm.useLawnmower = (0, _concat.default)(_context = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context, (0, _slice.default)($$a).call($$a, $$i + 1)));
          }
        } else {
          _vm.useLawnmower = $$c;
        }
      }
    }
  }), _c('span', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._v(" Use lawnmower")]), _vm.useLawnmower ? _c('div', {
    staticClass: "lawnmower-info"
  }, [_vm._v(" Undernet is going green and avoiding power hungry datacenters! IRC from a lawnmower and learn more "), _c('a', {
    attrs: {
      "href": "https://www.undernet.org/news/undernet-goes-green",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("here")])]) : _vm._e()]), _vm.showChannel ? _c('input-text', {
    staticClass: "kiwi-welcome-simple-channel",
    attrs: {
      "label": _vm.$t('channel')
    },
    model: {
      value: _vm.channel,
      callback: function callback($$v) {
        _vm.channel = $$v;
      },
      expression: "channel"
    }
  }) : _vm._e(), _c('label', {
    staticClass: "kiwi-welcome-simple-have-password"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.undernet.showLogin,
      expression: "undernet.showLogin"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.undernet.showLogin) ? _vm._i(_vm.undernet.showLogin, null) > -1 : _vm.undernet.showLogin
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.undernet.showLogin,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.undernet, "showLogin", (0, _concat.default)($$a).call($$a, [$$v]));
          } else {
            var _context2;
            $$i > -1 && _vm.$set(_vm.undernet, "showLogin", (0, _concat.default)(_context2 = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context2, (0, _slice.default)($$a).call($$a, $$i + 1)));
          }
        } else {
          _vm.$set(_vm.undernet, "showLogin", $$c);
        }
      }
    }
  }), _c('span', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._v(" Login using services")])]), _vm.undernet.showLogin ? [_c('input-text', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "kiwi-welcome-simple-password",
    attrs: {
      "label": _vm.$t('username')
    },
    model: {
      value: _vm.undernet.username,
      callback: function callback($$v) {
        _vm.$set(_vm.undernet, "username", $$v);
      },
      expression: "undernet.username"
    }
  }), _c('input-text', {
    staticClass: "kiwi-welcome-simple-password",
    attrs: {
      "label": _vm.$t('password'),
      "type": "password"
    },
    model: {
      value: _vm.password,
      callback: function callback($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }), _vm.undernet.showTotp ? [_c('input-text', {
    staticClass: "kiwi-welcome-simple-password",
    attrs: {
      "label": '2FA token',
      "type": "password"
    },
    model: {
      value: _vm.undernet.totp,
      callback: function callback($$v) {
        _vm.$set(_vm.undernet, "totp", $$v);
      },
      expression: "undernet.totp"
    }
  })] : [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.undernet.showTotp,
      expression: "undernet.showTotp"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.undernet.showTotp) ? _vm._i(_vm.undernet.showTotp, null) > -1 : _vm.undernet.showTotp
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.undernet.showTotp,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.undernet, "showTotp", (0, _concat.default)($$a).call($$a, [$$v]));
          } else {
            var _context3;
            $$i > -1 && _vm.$set(_vm.undernet, "showTotp", (0, _concat.default)(_context3 = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context3, (0, _slice.default)($$a).call($$a, $$i + 1)));
          }
        } else {
          _vm.$set(_vm.undernet, "showTotp", $$c);
        }
      }
    }
  }), _c('span', [_vm._v(" 2FA token ")])])], _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.undernet.hideHost,
      expression: "undernet.hideHost"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.undernet.hideHost) ? _vm._i(_vm.undernet.hideHost, null) > -1 : _vm.undernet.hideHost
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.undernet.hideHost,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.undernet, "hideHost", (0, _concat.default)($$a).call($$a, [$$v]));
          } else {
            var _context4;
            $$i > -1 && _vm.$set(_vm.undernet, "hideHost", (0, _concat.default)(_context4 = (0, _slice.default)($$a).call($$a, 0, $$i)).call(_context4, (0, _slice.default)($$a).call($$a, $$i + 1)));
          }
        } else {
          _vm.$set(_vm.undernet, "hideHost", $$c);
        }
      }
    }
  }), _c('span', [_vm._v(" Hide hostname ")])])] : _vm._e(), _c('captcha', {
    attrs: {
      "network": _vm.network
    }
  }), !_vm.network || _vm.network.state === 'disconnected' ? _c('button', {
    staticClass: "u-button u-button-primary u-submit kiwi-welcome-simple-start",
    attrs: {
      "disabled": !_vm.readyToStart,
      "type": "submit"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.buttonText)
    }
  }) : _c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })], 2)]], 2)]);
};
var staticRenderFns = exports.staticRenderFns = [];